@if (users) {
    <div class="summary">
        @for (s of summary; track s.label) {
            <div class="stat" [matTooltip]="s.hint">
                <div class="stat-value">{{s.value}}</div>
                <div class="stat-label">{{s.label}}</div>
            </div>
        }
    </div>
    @if (data.length > 0) {
        <app-table [columns]="columns" [data]="data" [rowSelect]="false" (rowEvent)="handleRowEvent($event)"></app-table>
    }@else {
        <p class="empty">No users have access to this organisation yet.</p>
    }
}
